import axios from 'axios';
import { isAuthorizationError } from '../api';

export default function isUnhandledError(e: Error) {
  return axios.isCancel(e) || isAuthorizationError(e);
}
